/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class LeaveBalanceTabDirective {
    public restrict = 'E';
    public scope;
    public template;
    public value;

    constructor(private Process: IProcessService, private bsLoadingOverlayService: IBsLoadingService, private Orgs: IOrgsService) {
        this.restrict = 'E';
        this.scope = {
        queryType: '=',
        leaveData: '=',
        saveFunc: '&?',
        canEdit: '=?',        
    }; 
    
    //leaveData.leave_per_year != leaveData.leave_start && leaveData.leave_start > 0
        this.template = `
        <div>
            <div class="row whiteBackground" ng-if="leaveData">
                <div class="col-md-1 d-none d-lg-block">
                </div>
                <div class="col-md-5">
                    <div class="content-wrapper whiteBackground">
                        <div class="title">
                            {{leaveData.title}} Leave
                        </div>
                        <canvas class="chart chart-doughnut" data-chart-data="leaveData.values" data-chart-labels="leaveData.labels" data-chart-legend="leaveData.legend" data-chart-options="{responsive: true, maintainAspectRatio: true, animation: false, legend: {display: true, position: 'bottom'}}">
                        </canvas>
                    </div>
                </div>
                <div class="col-md-5">
                    <table class="table table-material table-sm col-xs-12 col-sm-12 col-md-6">
                        <thead>
                            <tr>
                                <th class="first_col sorted_by_this"></th>
                                <th class="text-center">This Year</th>
                                <th>Next Year</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            <tr>
                                <td class="first_col sorted_by_this">
                                    <label class="md-label-custom">
                                        <span ng-if="leaveData.type !== 'sick'">Leave for the Year</span>
                                        <span ng-if="leaveData.type === 'sick'">Sick Leave Allowance</span>
                                    </label>
                                    <div class="d-inline-block newFeature more-inline-info">
                                        <i class="material-icons more-info">info</i>
                                        <md-tooltip md-direction="bottom">
                                            Number of leave days that the employee is entitled to per year
                                        </md-tooltip>
                                    </div>
                                    <div ng-if="leaveData.leave_per_year != leaveData.leave_start && leaveData.leave_start > 0">
                                        <label class="md-label-custom">
                                            <span style="font-size: smaller">Starting Balance for this Year</span>
                                        </label>
                                        ({{leaveData.leave_start}})
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="fields">
                                        <div class="field flex-center">
                                            <inline-edit-number value="leaveData.leave_per_year" save-func="saveLeaveEdit(args)" validate-func="validateLeave0or5(args)" can-edit="canEdit" min="0" class="leave-tab-num-edit"></inline-edit-number>
                                        </div>
                                    <!--{{leaveData.leave_per_year}}-->
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="field">{{leaveData.leave_per_year}}</div>
                                </td>
                            </tr>
                            
                            <tr ng-if="leaveData.type=='paid'">
                                <td class="first_col sorted_by_this">
                                    <label class="md-label-custom">Carried Over</label>
                                    <div class="d-inline-block newFeature more-inline-info">
                                        <i class="material-icons more-info">info</i>
                                        <md-tooltip md-direction="bottom">
                                            Number of leave days that was carried over from previous year
                                        </md-tooltip>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="fields">{{leaveData.carried_over}}</div>
                                </td>
                                <td class="text-center">
                                    <div class="field">{{org.extra.leave.show_next_year_carried_forward ? leaveData.carried_over_ny : 0}}</div>
                                </td>
                            </tr>
                            
                            <tr ng-if="leaveData.type !== 'sick'">
                                <td class="first_col sorted_by_this">
                                    <label class="md-label-custom">Leave Day Adjustment</label>
                                    <div class="d-inline-block newFeature more-inline-info">
                                        <i class="material-icons more-info">info</i>
                                        <md-tooltip md-direction="bottom">
                                            Number of leave days that have been added or removed for the year
                                        </md-tooltip>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="fields">
                                        <div class="field flex-center">
                                            <inline-edit-number value="leaveData.leave_adjustment" save-func="saveLeaveEdit(args)" validate-func="validateLeave0or5(args)" can-edit="canEdit" min="-20" class="leave-tab-num-edit"></inline-edit-number>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="field"></div>
                                </td>
                            </tr>
                            
                            <tr ng-if="leaveData.type != 'sick'">
                                <td class="first_col sorted_by_this">
                                    <label class="md-label-custom">Leave Allocated</label>
                                    <div class="d-inline-block newFeature more-inline-info">
                                        <i class="material-icons more-info">info</i>
                                        <md-tooltip md-direction="bottom">
                                            Number of leave days booked that are still to be used
                                        </md-tooltip>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="fields">({{leaveData.leave_alloc}})</div>
                                </td>
                                <td class="text-center">
                                    <div class="field">({{leaveData.leave_alloc_ny}})</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="first_col sorted_by_this">
                                    <label class="md-label-custom">
                                    
                                        <span ng-if="leaveData.type !== 'sick'">Leave Used</span>
                                        <span ng-if="leaveData.type === 'sick'">Sick Days</span>
                                    </label>
                                    <div class="d-inline-block newFeature more-inline-info">
                                        <i class="material-icons more-info">info</i>
                                        <md-tooltip md-direction="bottom">
                                            Number of leave days booked that have been used
                                        </md-tooltip>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="fields">({{leaveData.leave_used}})</div>
                                </td>
                                <td class="text-center">
                                    <div class="field"></div>
                                </td>
                            </tr>

                            <tr>
                                <td class="first_col sorted_by_this">
                                    <label class="md-label-custom">Balance</label>
                                    <div class="d-inline-block newFeature more-inline-info">
                                        <i class="material-icons more-info">info</i>
                                        <md-tooltip md-direction="bottom">
                                            Number of leave days that can still be taken
                                        </md-tooltip>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="fields" style="font-weight: bold">{{leaveData.leave_balance}}</div>
                                </td>
                                <td class="text-center">
                                    <div class="field" style="font-weight: bold">{{org.extra.leave.show_next_year_carried_forward ? leaveData.leave_balance_ny : leaveData.leave_balance_ny - leaveData.carried_over_ny}}</div>
                                </td>
                            </tr>
                                
                        </tbody>
                    </table>
                </div>
              
                <div class="col-md-1 d-none d-lg-block">
                
                </div>
            </div>

        </div>
        `;
    }

    public link($scope: any, $element: any, attrs: any): void {
        $scope.org = {extra: {leave:{}}}
        this.Orgs.getMyOrg().then((org) => {
            $scope.org = org;   
            if (!org.extra){
                org.extra = {leave: {}}
            }
            if(!org.extra.leave){
                org.extra.leave = {}
            }
        });

        $scope.queryType = attrs.queryType;

        $scope.typeArray = [];
        $scope.disablePrev = true;
        $scope.disableNext = false;
        $scope.saveLeaveEdit = function (args: any) {
            if (args.old == args.new) {
                return;
            }

            if($scope.saveFunc !== undefined){
                args.leaveType = $scope.leaveData.type;
                args.bin_id =  $scope.leaveData.bucket_id;
                $scope.saveFunc({args: args});
            }
        }

        $scope.validateLeave0or5 = function (args: any) {
            if (!args.new) {
                return false;
            }
            // Check if there is at most 1 decimal point
            let decimalParts = args.new.split('.');
            if (decimalParts.length > 2) {
                return false;
            }

            // Check that the decimal part is only .0 or .5
            if (decimalParts.length == 2){
                let decimalNumber = parseInt(decimalParts[1]);
                if (decimalNumber !== 0 && decimalNumber !== 5) {
                    return false;
                }
            }
            return true;
        }
    }

    public static DirectiveFn(
        Process: IProcessService,
        bsLoadingOverlayService: IBsLoadingService,
        Orgs: IOrgsService
    ): LeaveBalanceTabDirective {
        return new LeaveBalanceTabDirective(Process, bsLoadingOverlayService, Orgs);
    }
}

LeaveBalanceTabDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService', 'Orgs'];

angular.module('beneple.global').directive('leaveBalanceTab', LeaveBalanceTabDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/leave_balance_tab.directive.ts